<script lang="ts">
	import { onMount } from 'svelte';
	import { format } from 'src/services/i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import { getDeviceSettings, readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import {
		get_gen_2_component_channel_structure,
		getSettingUiComponent,
		real_id,
	} from 'src/helpers/interface_helpers';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import { Button } from '@Shelly/shelly-design-system';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import PlugButton from './PlugButton.svelte';

	export let device;

	const id = real_id(device.id);

	$: settingsStore = getDeviceSettings(id);
	let settings = readDeviceSettings(id);
	$: settings = $settingsStore ?? settings;
	const plugUi = getSettingUiComponent(device);
	const channel = get_gen_2_component_channel_structure(device);
	let type = settings?.[plugUi].controls[channel].in_mode,
		loading = false,
		cache;

	onMount(() => {
		cache = type;
	});

	const sentRequest = async () => {
		if (JSON.stringify(cache) !== JSON.stringify(type)) {
			loading = true;

			let params = { config: { controls: { [channel]: { in_mode: type } } } };

			const res: SettingRequest = await gen2Request(device, `${plugUi}.SetConfig`, params);
			cache = type;
			onSettingsResponse(res, device);
			loading = false;
		}
	};
</script>

<PlugButton bind:value={type} />

<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequest}
	>{$format('button_save')}</Button
>
